window.addEventListener('load', () => {
    document.addEventListener('change', (e) => {
        const target = e.target.closest('.js-confirmation')
        if (!target) return

        disableFormSubmissionButton(target)
    })

    const disableFormSubmissionButton = (input) => {
        const isChecked = input.checked
        const form = input.closest('.js-form')
        const formSubmitButton = form.querySelector('.js-form-submit')

        formSubmitButton.toggleAttribute('disabled', !isChecked)
    }
})
